import { render, staticRenderFns } from "./chainanalysis.vue?vue&type=template&id=8b75a712&scoped=true"
import script from "./chainanalysis.vue?vue&type=script&lang=js"
export * from "./chainanalysis.vue?vue&type=script&lang=js"
import style0 from "./chainanalysis.vue?vue&type=style&index=0&id=8b75a712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b75a712",
  null
  
)

export default component.exports